import { render, staticRenderFns } from "./picFooter.vue?vue&type=template&id=02f7f0be&scoped=true"
import script from "./picFooter.vue?vue&type=script&lang=js"
export * from "./picFooter.vue?vue&type=script&lang=js"
import style0 from "./picFooter.vue?vue&type=style&index=0&id=02f7f0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@6.11.0_webpack@5.106.2__lodash@4_7525e931386638c3c14eac4707fea9f9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f7f0be",
  null
  
)

export default component.exports